const LINKS = [
  {
    href: 'https://abihome.de/impressum',
    i18n: {
      id: 'Sidebar.footer.imprint',
      defaultMessage: 'Imprint'
    }
  },
  {
    href: 'https://abihome.de/datenschutz',
    i18n: {
      id: 'Sidebar.footer.data.security',
      defaultMessage: 'Data security'
    }
  },
  {
    href: 'https://abihome.de/kontakt',
    i18n: {
      id: 'Sidebar.footer.contact.us',
      defaultMessage: 'Contact us'
    }
  }
]

export default LINKS



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/Footer/config/links.js